import { useUploadOrderEventDocuments } from '@klear/ui/hooks/use-upload-order-event-documents'
import { unsupportedDocumentFiles } from '@klear/ui/lib/upload-document'
import { useOrderEventInvalidate } from '@klear/ui/hooks/use-order-event-invalidate'
import { trpc } from '@klear/ui/lib/trpc'

export type EventCommitResult = { id?: number } | null

export type RunEventCommit = (args: { id: number | null }) => Promise<EventCommitResult>

export type SaveEventArgs = {
  traderId: number
  eventId: number | null
  keptDocumentIds: string[]
  originalDocumentIds: string[]
  files: File[]
  runCommit: RunEventCommit
}

export function useEventFormSave() {
  const invalidateOrderEvents = useOrderEventInvalidate()
  const { uploadOrderEventDocuments } = useUploadOrderEventDocuments()
  const deleteDocument = trpc.orderEvent.deleteDocument.useMutation()

  const save = async (args: SaveEventArgs): Promise<EventCommitResult> => {
    const { traderId, eventId, keptDocumentIds, originalDocumentIds, files, runCommit } = args
    const unsupported = unsupportedDocumentFiles(files)
    if (unsupported !== null) throw new Error(unsupported)

    const removed = originalDocumentIds.filter((id) => !keptDocumentIds.includes(id))
    for (const documentId of removed) {
      await deleteDocument.mutateAsync({ documentId, traderId })
    }

    const result = await runCommit({ id: eventId })
    const savedId = eventId ?? result?.id

    if (files.length > 0 && savedId != null && savedId > 0) {
      await uploadOrderEventDocuments({ files, orderEventId: savedId, traderId })
    }

    await invalidateOrderEvents()
    return result
  }

  return { save }
}
